var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVisainline = function SvgVisainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.908 27.783l-6.591 16.675-2.667-14.175c-.317-1.583-1.55-2.5-2.925-2.5H.942l-.15.709c2.216.483 4.725 1.258 6.25 2.083.933.508 1.2.95 1.508 2.15l5.05 19.55h6.7l10.267-24.5h-6.659v.008zm9.375 0l-5.241 24.5h6.341l5.242-24.5H33.283zM69.617 34.4l1.925 9.2h-5.259l3.334-9.2zm-.934-6.617a2.89 2.89 0 00-2.7 1.8l-9.508 22.7h6.65l1.325-3.658h8.125l.767 3.658h5.866l-5.116-24.5h-5.409zm-27.341 7.65c-.042 3.525 3.141 5.492 5.55 6.667 2.466 1.2 3.3 1.975 3.283 3.042-.017 1.641-1.967 2.366-3.792 2.4-3.183.05-5.033-.859-6.508-1.55l-1.15 5.366c1.483.684 4.208 1.275 7.05 1.3 6.658 0 11.008-3.283 11.033-8.383.025-6.467-8.941-6.825-8.875-9.708.025-.875.859-1.809 2.692-2.05.908-.117 3.408-.209 6.25 1.1l1.117-5.192c-1.525-.558-3.492-1.083-5.934-1.083-6.266 0-10.675 3.333-10.708 8.1",
    fill: "url(#visa_inline_svg__paint0_linear_2776_29852)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa_inline_svg__paint0_linear_2776_29852",
    x1: 79.208,
    y1: 40,
    x2: 0.792,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#122D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#1A2166"
  })))));
};
export default SvgVisainline;